'use client'

import { Image } from '@/components'
import { useBoolean } from '@/hooks'
import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { FilterSidebar } from './filter-sidebar'

type Props = {
  aggregations: IAggregations[] | undefined
  isLoading?: boolean
  onFilterApplied?: () => void
}

export const FilterButton = ({ aggregations, isLoading, onFilterApplied }: Props) => {
  const { value: open, onToggle } = useBoolean()
  const t = useTranslations()

  return (
    <>
      <Box
        sx={{
          display: { xs: 'flex', xl: 'none' },
          alignItems: {
            xs: 'baseline',
            md: 'center',
          },
          gap: 0.5,
          cursor: 'pointer',
          flexShrink: 0,
          p: '0.5rem 0.8rem',
          backgroundColor: 'background.paper',
          borderRadius: 1,
          transition: '0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'primary.main',
            color: 'white',
            '& img': {
              filter: 'invert(1)',
            },
          },
        }}
        onClick={onToggle}
      >
        <Image src="/assets/images/icon_filter.svg" alt="Bộ lọc sản phẩm" />
        <Typography component={'span'}>{t('Bộ lọc')}</Typography>
      </Box>
      <FilterSidebar
        open={open}
        onClose={onToggle}
        isLoading={isLoading}
        aggregations={aggregations || []}
        onFilterApplied={onFilterApplied}
      />
    </>
  )
}
